module.exports = __webpack_public_path__ + "static/media/200.09eb58fc.svg";